// ============================================================
// KONFIGURACJA — dopasuj do swojego backendu
// ------------------------------------------------------------
// API_KEY trafia do przeglądarki. Dla produkcji ZALECANE jest
// wystawienie własnego endpointu-proxy (bez klucza po stronie
// klienta), który po stronie serwera wywoła calculateFX oraz
// prześle leada do CRM.
//
// W trybie deweloperskim CRA działa na :3000, a backend na :3001.
// Najprościej dodać w package.json:  "proxy": "http://localhost:3001"
// i zostawić API_BASE jako "" — wtedy /api/... trafi do backendu.
// ============================================================
export const CONFIG = {
  API_BASE: "https://apiloan.a2synergy.pl", // "" = ten sam host / proxy CRA; albo "https://api.twojadomena.pl"
  FX_ENDPOINT: "/api/fx/calculate", // endpoint z server.js
  API_KEY: "lck_9645ba89e0cdf1cea84011cb59e0b510913561910c84c264", // nagłówek X-API-Key
  SEND_LEAD: true,
};

// Lista banków (nazwa + następstwo prawne). Dostosuj wedle potrzeb.
export const BANKS = [
  ["mBank S.A.", "nast. BRE Bank S.A., MultiBank S.A."],
  ["Bank Millennium S.A.", "nast. Euro Bank S.A."],
  ["Bank BPH S.A.", "nast. GE Money Bank S.A."],
  ["Raiffeisen International AG", "nast. Raiffeisen Bank Polska / Polbank"],
  ["Getin Noble Bank S.A.", "nast. Getin Bank, Metrobank, DomBank"],
  ["Santander Consumer Bank S.A.", "nast. PTF Bank S.A."],
  ["Erste Bank Polska S.A.", "nast. Kredyt Bank, BZWBK S.A."],
  ["ING Bank Śląski S.A.", ""],
  ["PKO BP S.A.", "nast. Nordea Bank Polska S.A."],
  ["Bank Pekao S.A.", "nast. części kredytów Banku BPH"],
  ["Deutsche Bank S.A.", ""],
  ["BNP Paribas S.A.", "nast. BGŻ S.A., Fortis Bank S.A."],
  ["Bank Ochrony Środowiska S.A.", ""],
  ["DnB Bank Polska S.A.", ""],
  ["Inny bank", ""],
];

export const MONTHS = [
  "styczeń",
  "luty",
  "marzec",
  "kwiecień",
  "maj",
  "czerwiec",
  "lipiec",
  "sierpień",
  "wrzesień",
  "październik",
  "listopad",
  "grudzień",
];
